import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiTooltipStyles = {
    styleOverrides: {
        tooltip: {
            '&.tooltip-white': {
                maxWidth: '264px',
                margin: '0 14px',
                backgroundColor: Palette.white,
                color: Palette.black,
                padding: '22px 20px',
                boxShadow: Palette.boxShadow.elevation4,
                fontSize: '11px',
                fontWeight: '400',
                lineHeight: '16px',
                borderRadius: '16px',
                marginTop: '20px !important',
                '& .MuiTooltip-arrow::before': {
                    backgroundColor: Palette.white,
                },
                '&--small': {
                    padding: '16px',
                },
                '&--import-table': {
                    padding: '24px',
                    borderRadius: '16px',
                    fontSize: '11px',
                    fontWeight: '600',
                    lineHeight: '16px',
                    '& .address-suggestions': {
                        '& .MuiTypography-root': {
                            fontSize: '11px',
                            fontWeight: '600',
                            lineHeight: '16px',
                            marginBottom: '12px',
                        },
                        '& .address-option': {
                            fontWeight: '400',
                            padding: '8px 16px',
                            borderRadius: '8px',
                            backgroundColor: Palette.gray.gray50,
                            '&:hover': {
                                backgroundColor: Palette.yellow.yellow50,
                            },
                            '& + .address-option': {
                                marginTop: '2px',
                            },
                        },
                    },
                },
            },
            '&.tooltip-black': {
                backgroundColor: Palette.black,
                color: Palette.white,
                padding: '4px 8px',
                fontSize: '11px',
                fontWeight: '400',
                lineHeight: '16px',
                borderRadius: '4px',
                '& .MuiTooltip-arrow::before': {
                    backgroundColor: Palette.black,
                },
            },
            '&.tooltip-visibility': {
                top: '-10px',
                position: 'relative',
            },
            '&.tooltip-campaign': {
                backgroundColor: Palette.gray.gray900,
                color: Palette.white,
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '16px',
                borderRadius: '12px',
                padding: '24px',
                marginLeft: '18px',
                '& .MuiTooltip-arrow::before': {
                    backgroundColor: Palette.gray.gray900,
                },
            },
            '&.measurements-tooltip': {
                padding: '24px',
                margin: '6px 0 0 0 !important',
                '& .MuiTypography-root.MuiTypography-caption': {
                    fontSize: '11px',
                    lineHeight: '16px',
                    fontWeight: '400',
                    letterSpacing: '-0.11px',
                    display: 'block',
                    padding: '0',
                    '& + .MuiTypography-root.MuiTypography-caption': {
                        marginTop: '8px',
                    },
                },
                '& .invalid': {
                    backgroundColor: Palette.red.red200,
                    display: 'inline-block',
                    padding: '0 2px',
                    borderRadius: '2px',
                },
            },
        },
    },
};
